import { EventEmitter, Injectable } from "@angular/core";
import { Tab } from "./tab.model";
// import { Comp1Component } from "./components/comp1.component";
// import { Comp2Component } from "./components/comp2.component";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class TabService {

  public loadedTabs: Tab[] = [];
  public tabChengedEvent = new EventEmitter<number>();

  public tabs: Tab[] = [
    // new Tab(StudentregisterComponent, "Comp1 View", { parent: "AppComponent" }),
    // new Tab(FeeDayBookComponent, "Comp2 View", { parent: "AppComponent" })
  ];

  public tabSub = new BehaviorSubject<Tab[]>(this.tabs);

  public removeTab(index: number) {
    this.tabs.splice(index, 1);
    if (this.tabs.length > 0) {
      this.tabs[this.tabs.length - 1].active = true;
    }
    this.tabSub.next(this.tabs);
  }
  public removeTabByID(tabid: number) {
    var tabindex: number = 0;
    for (let i = 0; i < this.tabs.length; i++) {
      if (this.tabs[i].id == tabid) {
        tabindex = i;
      }
    }
    this.tabs.splice(tabindex, 1);
    if (this.tabs.length > 0) {
      this.tabs[this.tabs.length - 1].active = true;
    }
    this.tabSub.next(this.tabs);
  }

  public addTab(tab: Tab) {
    var exitsTab: Tab = null;
    for (let i = 0; i < this.tabs.length; i++) {
      if (this.tabs[i].active === true) {
        this.tabs[i].active = false;
      }

      if (this.tabs[i].id == tab.id) {
        this.tabs[i].active = true;
        exitsTab = this.tabs[i];

      }

    }
    if (exitsTab == null) {
      // tab.index = this.tabs.length + 1;
      tab.active = true;
      this.tabs.push(tab);
      this.tabSub.next(this.tabs);
      exitsTab = tab;
    }
    this.tabChengedEvent.emit(this.tabs.indexOf(exitsTab));

  }

  public openTab(id: number) {
    this.addTab(this.loadedTabs.find(x => x.id == id));
  }
}